import Vue from 'vue'
import Vuelidate from 'vuelidate'
import Vuex from 'vuex'
import store from './store'
import VueLazyload from 'vue-lazyload'
import './bootstrap'


Vue.use(VueLazyload,{
    lazyComponent: true
  })
Vue.use(Vuelidate)
Vue.use(Vuex)

Vue.component('modal-app', require('./components/Modal.vue').default);

 Vue.component('thanks-app', require('./components/Thanks.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    store,
    data: () => ({

    }),
    computed:{
        getThanks: function(){
            return this.$store.getters.getThanks
        }
    },
    mounted(){

    }
});
